import axios from 'axios'
import {AuthModel, LoginResult, SecondFactorMethod, UserModelResponse} from './_models'
import {env} from "../../../../env";

const API_URL = env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/api/security/user-data`
export const LOGIN_URL = `${API_URL}/api/security/login`
export const LOGIN_SECOND_FACTOR_URL = `${LOGIN_URL}/second-factor`
export const LOGIN_PASSKEY_OPTIONS_URL = `${LOGIN_URL}/passkey-options`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<LoginResult>(LOGIN_URL, {
    'login': email,
    'password': password,
  })
}

/** The second step of a sign-in: a code (`code`) or a passkey (`assertion`). */
export function submitSecondFactor(
  challenge: string,
  method: SecondFactorMethod,
  proof: { code: string } | { assertion: Record<string, unknown> }
) {
  return axios.post<AuthModel>(LOGIN_SECOND_FACTOR_URL, { challenge, method, ...proof })
}

export function getPasskeyLoginOptions(challenge: string) {
  return axios.post<{ success: boolean; options: any }>(LOGIN_PASSKEY_OPTIONS_URL, { challenge })
}

export function getUserByToken(token: string) {
  return axios.get<UserModelResponse>(GET_USER_BY_ACCESSTOKEN_URL)
}
